<template>
    <div>
        <h2 class="titulo"><span class="text--primary">Selecione o Produto ></span> Selecione o Bem</h2>

        <div v-if="!pedido.id_reserva">
            <div class="mt-4 ml-2 mr-2">
                <v-divider class="lightgray mb-8"></v-divider>
                <v-layout pa-4>
                    <v-flex class="col">
                        <v-layout class="row-padding" wrap>
                            <v-flex class="col" xs12 sm6 lg4>
                                <Autocomplete label="Plano de venda: " id="FieldPlanoVenda" :items="planosAutoComplete"
                                              v-input-filter="[$filters.textnumeric]" v-model="formulario_filtro.plano_venda"
                                              item-text="display_plano" item-value="id_plano_venda"
                                              placeholder="Selecione o plano de venda" />
                            </v-flex>
                            <v-flex class="col" xs12 sm6 lg4>
                                <Autocomplete label="Grupo: " id="FieldGrupo" :items="gruposAutoComplete"
                                              v-input-filter="[$filters.textnumeric]" v-model="formulario_filtro.grupo"
                                              item-text="cd_grupo" item-value="id_grupo" placeholder="Selecione o grupo" />
                            </v-flex>
                            <v-flex class="col" xs12 sm6 lg4>
                                <Autocomplete label="Tipo de Grupo:" id="FieldTipoGrupo" :items="FiltroTiposGrupo"
                                              v-model="formulario_filtro.tipo_grupo" item-text="label" item-value="value"
                                              placeholder="Selecione o tipo de grupo" />
                            </v-flex>
                            <v-layout class="justify-end" wrap>
                                <v-flex v-if="!filter_open" class="col d-flex" sm3 lg2 mb-2>
                                    <v-input style="align-self: flex-end">
                                        <v-btn color="primary" block @click="filtrar" id="filtrar">Filtrar</v-btn>
                                    </v-input>
                                </v-flex>
                                <v-flex v-if="!filter_open" class="col d-flex" sm3 lg2 mb-2>
                                    <v-input style="align-self: flex-end">
                                        <v-btn color="secondary" block @click="limpar">
                                            Limpar
                                        </v-btn>
                                    </v-input>
                                </v-flex>
                            </v-layout>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </div>
        </div>
        <v-divider class="ma-2 lightgray"></v-divider>
        <ListDialog v-model="dialog_grupos" title="Grupos disponíveis:" :items="grupos" placeholder="Selecione o grupo"
                    show-close-button :search-keys="['cd_grupo']">
            <template v-slot:item="props">
                <v-list-item @click="selecionarGrupo(props.item)">
                    {{ trimZeros(props.item.cd_grupo) }}
                </v-list-item>
            </template>
        </ListDialog>
        <a class="transition" @click="toggleFiltro">
            <v-layout>
                <span class="mais-filtros">
                    Mais filtros
                    <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                </span>
            </v-layout>
        </a>
        <collapse-transition>
            <div v-if="filter_open" class="mt-4 ml-2 mr-2">
                <v-layout pa-4>
                    <v-flex class="col">
                        <v-layout class="row-padding" wrap>
                            <v-flex class="col" xs12 sm6 lg4>
                                <m-text-field outlined v-uppercase label="Nome do Bem:" v-model="formulario_filtro.nome" />
                            </v-flex>
                            <v-flex class="col" xs12 sm6 lg4>
                                <m-text-field outlined v-uppercase label="Código do Bem:" v-input-filter="[$filters.numeric]" v-model="formulario_filtro.codigo_bem" />
                            </v-flex>
                            <v-flex class="col" xs12 sm6 lg4>
                                <MoneyTextField outlined label="Valor de parcela inicial:"
                                                v-model="formulario_filtro.vl_parcela_min" />
                            </v-flex>
                            <v-flex class="col" xs12 sm6 lg4>
                                <MoneyTextField outlined label="Valor de parcela final:"
                                                v-model="formulario_filtro.vl_parcela_max" />
                            </v-flex>
                            <v-flex class="col" xs12 sm6 lg4>
                                <MoneyTextField outlined label="Valor do bem inicial:"
                                                v-model="formulario_filtro.vl_bem_min" />
                            </v-flex>
                            <v-flex class="col" xs12 sm6 lg4>
                                <MoneyTextField outlined label="Valor do bem final:"
                                                v-model="formulario_filtro.vl_bem_max" />
                            </v-flex>
                            <v-flex class="col d-flex" sm3 lg2 mb-2>
                                <v-input style="align-self: flex-end">
                                    <v-btn color="primary" block @click="filtrar">Filtrar</v-btn>
                                </v-input>
                            </v-flex>
                            <v-flex class="col d-flex" sm3 lg2 mb-2>
                                <v-input style="align-self: flex-end">
                                    <v-btn color="secondary" block @click="limpar">
                                        Limpar
                                    </v-btn>
                                </v-input>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </div>
        </collapse-transition>
        <v-divider class="ma-2 lightgray"></v-divider>
        <v-data-iterator
            :page.sync="page"
            :items="catalogo"
            :items-per-page.sync="itemsPerPage"
            :server-items-length="totalItems"
            :loading="carregandoPaginacao"
            :footer-props="catalogoOptions"
            @update:page="onPageChange"
            @update:items-per-page="onItemsPerPageChange">
            <template slot="no-data">
                <h2 class="col text-center flex">
                    Nenhum bem para: <span class="text--primary">{{ pedido.produto.nome_produto }}</span>
                </h2>
            </template>
            <template v-slot="props">
                <div class="row-padding mx-3">
                    <v-btn outlined color="primary" border="primary" class="ordenar position-absolute"
                           @click="abrirDialogOrdenarBens()">
                        Ordenar
                    </v-btn>
                    <v-layout wrap class="catalogo mt-12 mb-12">
                        <v-flex v-for="(bem, index) in props.items" :key="index" lg3 md6 class="col mb-6">
                            <v-card flat class="text-center d-flex layout column round-corner" row
                                    style="height: 100%;">
                                <v-card-title class="flex-grow-1">
                                    <img :src="bem.imagemBem" :alt="bem.titulo" />
                                    <h2 class="flex">{{ bem.nm_bem }}</h2>
                                </v-card-title>
                                <h3 class="flex" style="margin-bottom: 5px">Cód.: {{ bem.cd_bem }}</h3>
                                <v-card-text style="flex: none !important;">
                                    <p>Valor do bem</p>
                                    <h3 class="valor-bem">{{ bem.vl_bem | money }}</h3>
                                    <p>Parcelas</p>
                                    <p v-if="parseFloat(bem.menor_vl_parcela) === parseFloat(bem.maior_vl_parcela)"
                                       class="mb-4" style="font-size: 1.1rem">
                                        A partir de <span class="font-weight-bold">{{ bem.maior_vl_parcela | money
                                        }}</span>
                                    </p>
                                    <p v-else class="mb-4" style="font-size: 1.1rem">
                                        De <span class="font-weight-bold">{{ bem.menor_vl_parcela | money }}</span> à
                                        <span class="font-weight-bold">{{ bem.maior_vl_parcela | money }}</span>
                                    </p>
                                    <v-btn color="primary" @click="selecionarBem(bem)" :id="'simular_' + bem.id_bem">
                                        Simular
                                    </v-btn>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </div>
                <DialogOrdenarBens v-model="dialogOrdenarBensVisible" @ordenar="ordenarBens" />
            </template>
        </v-data-iterator>

        <ListDialog v-model="dialog_planos" title="Planos disponíveis" :items="planos_selecionar"
                    @select="selecionarPlano" show-close-button placeholder="Selecione o plano" no-search
                    :item-text="planoTextDialog" />

        <v-btn text color="secondary" @click="voltar()">Voltar</v-btn>
    </div>
</template>

<script>
  import { notification, trimZeros } from '@/plugins/helpers'
  import { mapGetters, mapState } from 'vuex'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import { FiltroTiposGrupo } from '../../../plugins/constants'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import DialogOrdenarBens from '@/components/DialogOrdenarBens.vue'
  // import PreparacaoAmbienteBroker from '@/components/broker/PreparacaoAmbienteBroker.vue'
  import preparacaoAmbienteBrokerMixin from '@/mixins/broker/preparacaoAmbienteBrokerMixin'

  export default {
    name: 'SelecionarBem',
    components: {
      DialogOrdenarBens
      // PreparacaoAmbienteBroker
    },
    mixins: [preparacaoAmbienteBrokerMixin],
    props: { value: Object, filtroCatalogo: Object },
    data: () => ({
      dialogOrdenarBensVisible: false,
      autocomplete_params: {},
      filtrado: false,
      dialog_grupos: false,
      filter_open: false,
      imagemBem: null,
      catalogo_carregado: false,
      dialog_planos: false,
      planos_selecionar: [],
      grupos: [],
      planos: [],
      permite_todos_produtos: false,
      tipoDivergente: false,
      mostrarMensagemGenerica: true,
      mostrarAlertaTelaBens: false,
      pedido: {
        id_regiao_fiscal: null,
        id_tipo_venda: null,
        produto: {},
        grupo: {},
        plano: {
          nome_plano: '',
          id_plano_venda: 0,
          cd_plano_venda: '',
          id_taxa_plano: 0
        },
        bem: {
          id_bem: 0,
          nome_bem: '',
          valor_bem: 0,
          id_fabricante: 0,
          id_tipo_venda: 0,
          cd_bem: ''
        }
      },
      FiltroTiposGrupo,
      bens: [],
      nm_tabela_venda: null, // Armazena o nome da tabela retornado pelo broker
      filtro: {
        nome: '',
        codigo_bem: '',
        plano_venda: '',
        grupo: '',
        vl_parcela_min: '',
        vl_parcela_max: '',
        vl_bem_min: '',
        vl_bem_max: ''
      },
      formulario_filtro: {
        nome: '',
        codigo_bem: '',
        plano_venda: '',
        grupo: '',
        tipo_grupo: '',
        vl_parcela_min: '',
        vl_parcela_max: '',
        vl_bem_min: '',
        vl_bem_max: ''
      },
      page: 1,
      itemsPerPage: 12,
      totalItems: 0,
      planos_disponiveis: [],
      bensOriginais: [],
      lastErrorMessage: null,
      carregandoPaginacao: false
    }),
    computed: {
      ...mapState(['jornada_venda']),
      ...mapGetters([
        'dadosRestricaoVenda'
      ]),
      trimZeros: () => trimZeros,
      bensPorPagina () {
        return this.itemsPerPage
      },
      catalogoOptions () {
        return {
          'items-per-page-options': [12, 24, 48]
        }
      },
      catalogo () {
        // Retorna os bens diretamente sem filtro client-side
        // pois a filtragem é feita no servidor
        return this.bens
      },
      totalPages () {
        return Math.ceil(this.totalItems / this.itemsPerPage)
      },
      planosListados () {
        // Usa os planos_disponiveis vindos do backend ao invés de extrair dos bens
        // Isso evita agrupamento incorreto de múltiplos planos
        return this.planos_disponiveis || []
      },
      gruposListados () {
        // Usa os grupos vindos do backend ao invés de extrair dos bens
        // Isso evita agrupamento incorreto de múltiplos grupos
        return this.grupos || []
      },
      planosAutoComplete () {
        return this.planosListados.map(plano => ({
          id_plano_venda: plano.ID_Plano_Venda,
          cd_plano_venda: plano.CD_Plano_Venda,
          nm_plano_venda: plano.NM_Plano_Venda,
          id_empresa: plano.ID_Empresa,
          display_plano: `${plano.CD_Plano_Venda} - ${plano.NM_Plano_Venda}`
        }))
      },
      gruposAutoComplete () {
        return this.gruposListados.map(grupo => ({
          id_grupo: grupo.id_grupo,
          cd_grupo: grupo.cd_grupo
        }))
      }
    },
    watch: {
      bens (val) {
        if (val.length <= 0 && this.mostrarMensagemGenerica) {
          if (this.pedido.id_reserva && this.pedido.id_produto) {
            this.pedido.permitido_todos_produtos_reserva = true
            this.$emit('input', { ...this.pedido })
            if (this.lastErrorMessage) {
            notification(AlertTypes.ERROR, this.lastErrorMessage)
            } else {
            notification(AlertTypes.ERROR, 'Não foi encontrado condições de venda para o produto da sua reserva, sugerimos alterar o produto da venda e tentar novamente ou iniciar uma nova venda.')
            }
            return
          }
          if (this.lastErrorMessage) {
          notification(AlertTypes.ERROR, this.lastErrorMessage)
          } else {
          notification(AlertTypes.ERROR, 'Nenhum bem encontrado para as condições selecionadas.')
          }
        }
      }
    },
    async mounted () {
      this.formulario_filtro = { ...this.formulario_filtro, ...this.filtroCatalogo }
      this.filtro = { ...this.filtro, ...this.filtroCatalogo }
      this.pedido = Object.assign({}, this.pedido, this.value)
      this.permite_todos_produtos = this.$session.get('permite_venda_todos_produtos')

      // Verifica se deve mostrar a modal de preparação (quando usa broker)
      const usaBroker = this.$session.get('broker_fluxo_vendas_comum') || false
      this.nm_tabela_venda = this.$session.get('nm_tabela_venda')

      if (usaBroker && !this.$route.params?.skip_preparacao) {
        if (!this.nm_tabela_venda) {
          this.$emit('showModalBroker', true)
          return
        }
      }

      if (this.$parent.onAtualizarCatalogo) {
        this.$parent.onAtualizarCatalogo = false
        await this.onPreparacaoFinished()
        return // Já atualizou, não faz mais nada aqui!
      }

      const res = await this.getCatalogo()
      this.catalogo_carregado = true
      this.bens = res.data.bens || []
      await this.carregarImagensDosBens()
      this.bensOriginais = [...this.bens]
      this.planos_disponiveis = res.data.planos_disponiveis || []
      this.grupos = res.data.grupos || []
      // Armazena o nome da tabela para uso nas próximas requisições
      if (res.data.nm_tabela_venda) {
        this.nm_tabela_venda = res.data.nm_tabela_venda
      }
      // Armazena informações de paginação
      if (res.data.pagination) {
        this.totalItems = res.data.pagination.total
        this.page = res.data.pagination.current_page
        this.itemsPerPage = res.data.pagination.per_page
      }
      if (this.filtro.grupo || this.filtro.plano_venda) {
        this.filtrar()
      }
    },
    methods: {
      planoTextDialog: item => `${item.CD_Plano_Venda} - ${item.NM_Plano_Venda}`,
      async filtrar () {
        this.page = 1
        this.filtro = { ...this.formulario_filtro }
        const { grupo, plano_venda, tipo_grupo, vl_parcela_min, vl_parcela_max, vl_bem_min, vl_bem_max, nome, codigo_bem } = this.filtro
        this.tipoDivergente = false
        this.mostrarMensagemGenerica = true

        if (this.bens.length === 0 && grupo && tipo_grupo) {
          this.tipoDivergente = true
          this.mostrarMensagemGenerica = false
          notification(AlertTypes.WARN, 'Foi selecionado dois grupos com tipos divergentes, realize o filtro novamente.')
          return
        }

        if (grupo || plano_venda || tipo_grupo || nome || vl_bem_min || vl_bem_max || vl_parcela_min || vl_parcela_max || codigo_bem) {
          this.filtrado = true
          this.sendAnalytics(true)
          this.$vuetify.goTo(650)
          this.$emit('filtroCatalogo', this.filtro)
          // Recarrega o catálogo com os filtros aplicados
          await this.carregarCatalogo()
        } else {
          notification(AlertTypes.WARN, 'É necessário incluir ao menos uma informação para filtrar a listagem de bens.')
        }
      },
      limpar () {
        let clean = {
          nome: '',
          codigo_bem: '',
          plano_venda: '',
          grupo: '',
          tipo_grupo: '',
          vl_parcela_min: '',
          vl_parcela_max: '',
          vl_bem_min: '',
          vl_bem_max: ''
        }
        this.filtro = { ...clean }
        this.formulario_filtro = { ...clean }
        this.formulario_filtro.grupo = ''
        this.filtrado = false
        this.catalogo_carregado = false
        this.pedido.id_grupo = (this.pedido.id_reserva != null) ? this.pedido.id_grupo : ''
        this.formulario_filtro.plano_venda = ''
        this.page = 1 // Volta à primeira página
        this.carregarCatalogo()
        this.$emit('filtroCatalogo', this.filtro)
      },
      async carregarCatalogo () {
        this.carregandoPaginacao = true
        try {
          const res = await this.getCatalogo()

          this.bens = res.data.bens || []
          await this.carregarImagensDosBens()
          this.bensOriginais = [...this.bens]
          this.planos_disponiveis = res.data.planos_disponiveis || []
          this.grupos = res.data.grupos || []

          // Armazena o nome da tabela para uso nas próximas requisições
          if (res.data.nm_tabela_venda) {
            this.nm_tabela_venda = res.data.nm_tabela_venda
          }

          // Atualiza informações de paginação
          if (res.data.pagination) {
            this.totalItems = res.data.pagination.total
            this.page = res.data.pagination.current_page
            this.itemsPerPage = res.data.pagination.per_page
          }

          this.catalogo_carregado = true
        } catch (error) {
          console.error('Erro ao carregar catálogo:', error)
        } finally {
          this.carregandoPaginacao = false
        }
      },
      onPageChange (newPage) {
        this.page = newPage
        this.carregarCatalogo()
      },
      onItemsPerPageChange (newItemsPerPage) {
        this.itemsPerPage = newItemsPerPage
        this.page = 1
        this.carregarCatalogo()
      },
      async carregarImagensDosBens () {
        await Promise.all(
          this.bens.map(async bem => {
            if (!bem.id_bem) return
            const url = await this.carregarImagemBem(bem.id_bem)
            this.$set(bem, 'imagemBem', url)
          })
        )
      },
      async carregarImagemBem (id_bem) {
        try {
          const response = await this.$http.get(`/compra/imagembem/${id_bem}`, {
            responseType: 'blob',
            headers: {
                'Cache-Control': 'no-cache'
              }
          })
          return URL.createObjectURL(response.data)
        } catch (e) {
          console.error('Erro carregando imagem do bem', id_bem, e)
          return null
        }
      },
      async getCatalogo (id_grupo, id_plano_venda) {
        const id_empresa = this.$session.get('id_empresa')
        const id_unidade_negocio = this.$session.get('id_unidade_negocio')
        const id_ponto_venda = this.$session.get('id_ponto_venda')
        const id_comissionado = this.$session.get('id_comissionado_venda')
        const flavor = this.$session.get('flavor')
        const ambientes = this.$session.get('ambiente')
        const tipo_grupo = this.formulario_filtro.tipo_grupo
        id_grupo = id_grupo || this.pedido.id_grupo
        const unidadeCondicoesVenda = ambientes && ambientes.unidade_condicoes_venda

        // Base dos parâmetros
        const params = {
          id_empresa,
          id_produto: this.pedido.produto.id_produto,
          permite: this.permite_todos_produtos,
          dadosRestricaoVenda: this.dadosRestricaoVenda,
          ...(tipo_grupo && { tipo_grupo }), // Adiciona tipo_grupo apenas se for truthy
          id_unidade_negocio,
          id_ponto_venda,
          id_comissionado,
          flavor,
          ...(unidadeCondicoesVenda && { unidade_condicoes_venda: unidadeCondicoesVenda }),
          // Envia o nome da tabela se já foi criada (para reutilização)
          ...(this.nm_tabela_venda && { nm_tabela_venda: this.nm_tabela_venda }),
          // Parâmetros de paginação
          page: this.page,
          per_page: this.itemsPerPage,
          // Parâmetros de filtro
          ...(this.filtro.nome && { nome: this.filtro.nome }),
          ...(this.filtro.codigo_bem && { codigo_bem: this.filtro.codigo_bem }),
          ...(this.filtro.grupo && { grupo: this.filtro.grupo }),
          ...(this.filtro.plano_venda && { plano_venda: this.filtro.plano_venda }),
          ...(this.filtro.vl_bem_min && { vl_bem_min: this.filtro.vl_bem_min }),
          ...(this.filtro.vl_bem_max && { vl_bem_max: this.filtro.vl_bem_max }),
          ...(this.filtro.vl_parcela_min && { vl_parcela_min: this.filtro.vl_parcela_min }),
          ...(this.filtro.vl_parcela_max && { vl_parcela_max: this.filtro.vl_parcela_max }),
          ordenacao_campo: this.ordenacao?.campo,
          ordenacao_ordem: this.ordenacao?.ordem
        }

        // Adiciona parâmetros dinamicamente
        if (this.pedido.id_reserva) {
          params.id_reserva = this.pedido.id_reserva
          params.id_grupo = id_grupo
          params.id_bem_reserva = this.pedido.id_bem
          params.id_plano_venda_reserva = this.pedido.id_plano_venda
        }

        // Retorna a requisição com os parâmetros montados
        return this.$http.get(`/compra/catalogo/${this.pedido.produto.id_produto}`, { params }).then((response) => {
          const data = response.data

          if (data.Msg_Erro) {
            this.lastErrorMessage = data.Msg_Erro
            if (this.mostrarAlertaTelaBens) {
              notification(AlertTypes.ERROR, `Caro parceiro, ocorreu um erro ao carregar algumas informações! Entre em contato com a Área de Suporte indicando o seguinte erro: ${data.Msg_Erro}`)
              this.mostrarMensagemGenerica = false
            }
          } else if (Array.isArray(data.msgStack)) {
            for (let mensagem of data.msgStack) {
              notification(mensagem.type, mensagem.message)
              this.mostrarMensagemGenerica = false
            }
          }
          return response
        })
          .catch((error) => {
            if (this.mostrarAlertaTelaBens) {
              if (error.response?.data?.Msg_Erro) {
                notification(AlertTypes.ERROR, `Caro parceiro, ocorreu um erro ao carregar algumas informações! Entre em contato com a Área de Suporte indicando o seguinte erro: ${error.response.data.Msg_Erro}`)
              } else {
                notification(AlertTypes.ERROR, 'Caro parceiro, ocorreu um erro ao carregar algumas informações! Tente novamente mais tarde e caso o erro persista, entre em contato com a Área de Suporte.')
              }
            }
          })
      },
      abrirDialogOrdenarBens () {
        this.dialogOrdenarBensVisible = true
      },
      ordenarBens (ordenacao) {
        this.ordenacao = ordenacao
        this.page = 1
        this.carregarCatalogo()
        this.dialogOrdenarBensVisible = false
      },
      toggleFiltro () {
        this.filter_open = !this.filter_open
      },
      selecionarBem (bem) {
        if (this.filtrado && this.formulario_filtro.grupo) {
          this.pedido.id_grupo = this.formulario_filtro.grupo // Para a proxima tela validar o filtro, coloquei no pedido por que ele já é enviado pra proxima tela.
        }
        this.pedido.id_regiao_fiscal = bem.id_regiao_fiscal
        this.pedido.id_tipo_venda = bem.id_tipo_venda
        this.pedido.id_empresa = bem.id_empresa
        this.pedido.bem.id_bem = bem.id_bem
        this.pedido.bem.nome_bem = bem.nm_bem
        this.pedido.bem.valor_bem = bem.vl_bem
        this.pedido.bem.id_fabricante = bem.id_fabricante
        this.pedido.bem.cd_bem = bem.cd_bem

        const planosDisponiveis = this.planosToArray(bem)

        const planosValidos = this.filtro.plano_venda ? planosDisponiveis.filter(p => p.ID_Plano_Venda === this.filtro.plano_venda) : planosDisponiveis

        if (planosValidos.length === 1) {
          this.selecionarPlano(planosValidos[0])
        } else if (planosValidos.length > 1) {
          this.planos_selecionar = _.sortBy(planosValidos, 'CD_Plano_Venda')
          this.dialog_planos = true
        }
      },
      planosToArray (bem) {
        if (!bem || bem.id_plano_venda == null) return []
        if (Array.isArray(bem.id_plano_venda)) return bem.id_plano_venda.filter(Boolean)
        if (typeof bem.id_plano_venda === 'object') return [bem.id_plano_venda]
        return []
      },
      hasPlano (bem, idPlano) {
        const planos = this.planosToArray(bem)
        return planos.some(p => p && p.ID_Plano_Venda === idPlano)
      },
      getIdGrupoByCdGrupo (cd_grupo) {
        const grupo = this.grupos.find(g => g.cd_grupo === cd_grupo)
        return grupo ? grupo.id_grupo : null
      },
      selecionarPlano (plano) {
        this.pedido.plano = {
          nome_plano: plano.NM_Plano_Venda,
          id_plano_venda: plano.ID_Plano_Venda,
          cd_plano_venda: plano.CD_Plano_Venda,
          id_taxa_plano: plano.id_taxa_plano
        }

        this.sendAnalytics()

        this.$emit('input', this.pedido)
        this.$emit('nextPage')
      },
      sendAnalytics (isFilter = false) {
        if (isFilter) {
          sendAnalyticsEvent(this.$gtag, 'produto_filtroBem', {
            plano_venda: this.filtro.plano_venda,
            grupo: this.filtro.grupo,
            source_menu: this.jornada_venda
          })
        }

        if (!isFilter) {
          sendAnalyticsEvent(this.$gtag, 'produto_selecionarBem', {
            nome_bem: this.pedido.bem.nome_bem,
            cod_bem: this.pedido.bem.cd_bem,
            plano_venda: this.pedido.plano.nome_plano,
            source_menu: this.jornada_venda
          })
        }
      },
      async onPreparacaoFinished () {
        // Quando a preparação do ambiente terminar, esconde a modal e carrega o catálogo
        const res = await this.getCatalogo()
        this.catalogo_carregado = true
        this.bens = res.data.bens || []
        await this.carregarImagensDosBens()
        this.bensOriginais = [...this.bens]
        this.planos_disponiveis = res.data.planos_disponiveis || []
        this.grupos = res.data.grupos || []

        // Armazena o nome da tabela para uso nas próximas requisições
        if (res.data.nm_tabela_venda) {
          this.nm_tabela_venda = res.data.nm_tabela_venda
        }

        // Armazena informações de paginação
        if (res.data.pagination) {
          this.totalItems = res.data.pagination.total
          this.page = res.data.pagination.current_page
          this.itemsPerPage = res.data.pagination.per_page
        }

        if (this.filtro.grupo || this.filtro.plano_venda) {
          this.filtrar()
        }
      },

      voltar () {
        this.mostrarAlertaTelaBens = false
        this.limpar()
        delete this.pedido.produto
        delete this.pedido.bem
        delete this.pedido.plano
        this.$emit('input', { ...this.pedido })
        this.$emit('prevPage')
      }
    }
  }
</script>

<style scoped lang="scss">

.mais-filtros {
    width: 100%;
    text-align: center;
}

.v-label {
    white-space: nowrap
}

.catalogo .v-card {
    border: 1px solid var(--gray);
}

.catalogo .v-card .v-card__title {
    padding-top: 0 !important;
}

.catalogo .v-card img {
    width: 100%;
    height: 150px;
    object-position: center;
    object-fit: contain;
}

.catalogo .v-card h2 {
    font-size: 1.7rem;
    color: var(--primary);
}

.catalogo .v-card .v-card__text {
    background: var(--gray);
    color: var(--dark);
}

.catalogo .v-card .v-card__text p {
    margin-bottom: 5px;
}

.catalogo .v-card .v-card__text h3 {
    margin-bottom: 10px;
}

.catalogo .v-card .v-card__text h3.valor-bem {
    color: var(--primary);
    font-size: 1.5rem;
}

.ordenar {
    font-weight: bold;
    background-color: #fff;
    height: 2.5rem !important;
    top: 65px;
    left: -6px;
    z-index: 1;
}
</style>
